import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Checkbox from '../../Form/Checkbox';

import postEditPost from '../../../api/graphql/mutations/postEditPost';
import massPostModif from '../../../api/graphql/mutations/massPostModif';
// import getPostBySlug from '../../../api/graphql/queries/getPostBySlug';

const height = { height: '1.2rem' };

const PostListItem = ({
  isLastItem = false, postDescription, postName, slugName, postCategory, handleDelete, _id, handleSelected, active, uncheck, allChecked, disableCheckBoxes, handleDuplicate, reusablePosts,
}) => {
  const [activeIndicator, setActiveIndicator] = useState(false);
  const [currentPost, setCurrentPost] = useState({});

  // / !!!
  // const [isLoaded, setIsLoaded] = useState(true);
  // const [isFirstLoad, setIsFirstLoad] = useState(true);


  const [checked, setChecked] = useState(false);

  // useEffect(() => {
  //   if (checked) { setChecked(false); }
  // }, [uncheck]);


  // useEffect(() => {
  //   setActiveIndicator(active);
  // }, [active]);

  useEffect(() => {
    if (slugName) {
      setActiveIndicator(active);
    } else {
      console.log('no slugName selected');
    }
  }, [active]);

  const handleActiveItem = async (slug) => {
    try {
      const obj = {};
      obj.posts = [slug];
      obj.publish = !activeIndicator;
      const res = await massPostModif(obj);
      const { isEdited } = res;
      if (isEdited) {
        setActiveIndicator(!activeIndicator);
      } else {
        console.log('Admin: there was an issue updating the posts in mass, please contact your admin');
      }
    } catch {
      err => console.log(err);
    }
  };

  const handleChange = (slug) => {
    setChecked(!checked);
    handleSelected(slug, !checked);
  };


  useEffect(() => {
    if (allChecked === true || allChecked === false) setChecked(allChecked);
  }, [allChecked]);

  return (
    <>
      <div className={`flex ${!isLastItem ? 'border-b-1 border-grey' :'border-b-2 border-black'} mx-3`}>
        {/* <div className="drag-box w-12 p-2 flex items-center justify-center cursor-move text-36 font-thin mb-1">=</div> */}
        <div className="flex items-center ">
          <Checkbox
            checked={checked}
            disabled={disableCheckBoxes || allChecked || reusablePosts}
            onChange={() => handleChange(slugName)}
            name={slugName}
            value="checkedB"
            color="default"
            inputProps={{
              'aria-label': 'checkbox with default color',
            }}
          />
        </div>
        <div className="flex cursor-pointer items-center justify-between w-full">

          <Link to={`/cms/structure/${postCategory}/${slugName}`}>
            {/* <div className="title self-center cursor-pointer text-black">{postDescription && postDescription.title && postDescription.title.en !== '' ? `${postDescription.title.en}` : `${slugName}`}</div> */}
            <div className="title self-center cursor-pointer text-black">{`${postName || slugName}`}</div>
          </Link>
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={() => {
                handleDuplicate(slugName);
              }}
              className="cursor-pointer ml-2"
            >
              <span className="font-icon1 icon-duplicate text-sm" />
            </button>
            <button
              type="button"
              onClick={() => {
                handleDelete(slugName, _id);
              }}
              className="cursor-pointer ml-2"
            >
              <span className="font-icon icon-trash text-sm" />
            </button>
            <label className="switch-no-text mb-0 py-0 ml-4 text-white" style={height}>
              <input
                className="switch-no-text"
                checked={activeIndicator}
                onChange={() => { handleActiveItem(slugName); }}
                type="checkbox"
              />
              <div className="switch-slider-no-text btn-gr switch-round" />
            </label>
            {/* <div className="switch-container">
  <label htmlFor="switch-button">
    <input
      className="switch bg-green-pin"
      checked={active}
      onChange={() => handleActive(!active)}
      type="checkbox"
      id="switch-button"
    />
    <div className="left-0">
      <div />
    </div>
  </label>
</div> */}
          </div>
        </div>
      </div>


    </>


  );
};

export default React.memo(PostListItem);
